import { Helmet } from "react-helmet";
import Clients from "../../components/clients/Clients";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

function ClientsPage({ setShow }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Our Clients | Vinca Horticulture & Landscaping </title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title="Our Clients" t={t} />
      <Clients t={t} />
    </>
  );
}

export default ClientsPage;
